import CssBaseline from "@material-ui/core/CssBaseline";
import AppBarContext from "@qpr/client-api-base/appbar/BusinessPortalAppBarContext";
import useAppBar from "@qpr/client-api-base/appbar/BusinessPortalAppBarHook";
import interceptorService from "@qpr/client-api-base/axios/interceptor";
import { AppCtxProvider } from "@qpr/client-api-base/context/AppCtxProvider";
import { ReportCtxProvider } from "@qpr/client-api-base/context/ReportCtxProvider";
import { ScrollCtxProvider } from "@qpr/client-api-base/context/ScrollContextProvider";
import UserContextProvider from "@qpr/client-api-base/context/UserContextProvider";
import { RTLProvider } from "@qpr/client-api-base/languageswitch/index";
import LogoutPage from "@qpr/client-api-base/logout/LogoutPage";
import LoginPage from "@qpr/client-api-base/pages/LoginPage";
import startBatcherService from "@qpr/client-api-base/querybuilder/QueryBatcher";
import Loader from "@qpr/client-api-base/ui/components/Loader";
import ErrorBoundary from "@qpr/client-api-base/ui/errors/index";
import AppContainer, {
  Auth,
  useCurrentTenant,
} from "@qpr/client-library/dist/esm";
import "App.css";
import "init";
import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import "resources/init";
import { SelectedReportContextProvider } from "state/SelectedReportContext";
import Theme from "theme/Theme";
import "typeface-open-sans";
import "typeface-roboto";
import Routes from "./Routes";
import BusinessPortalAppBar from "./components/toolbars/appbar/BusinessPortalAppBar";

// <QprFileThemeProvider themeName={tenant.symbol || "public"}>
interceptorService.setupInterceptors();
startBatcherService(200);
const Pages = () => {
  const tenant = useCurrentTenant();
  return (
    <div>
      <Theme>
        <Auth loginPage={<LoginPage />}>
          <UserContextProvider>
            <ReportCtxProvider>
              <AppCtxProvider>
                <AppBarContext.Provider value={useAppBar()}>
                  <SelectedReportContextProvider>
                    <RTLProvider>
                      <ErrorBoundary>
                        <BusinessPortalAppBar />
                        <ScrollCtxProvider>
                          <Routes />
                        </ScrollCtxProvider>
                      </ErrorBoundary>
                    </RTLProvider>
                  </SelectedReportContextProvider>
                </AppBarContext.Provider>
              </AppCtxProvider>
            </ReportCtxProvider>
          </UserContextProvider>
        </Auth>
      </Theme>
    </div>
  );
};
const App = () => {
  return (
    <Router>
      <AppContainer>
        <Switch>
          <Route path="/logout" component={LogoutPage} />
          <Route>
            <CssBaseline />
            <Suspense fallback={<Loader />}>
              <Pages />
            </Suspense>
          </Route>
        </Switch>
      </AppContainer>
    </Router>
  );
};
export default App;
